import { c as _c } from "react/compiler-runtime";
import { faMapMarker } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
import { Avatar } from 'shared/avatar';
import EmptyState from 'shared/empty-state';
import { Box, Grid } from 'shared/grid';
import Loader from 'shared/loader';
import { fetchService } from 'shared/redux/services/actions';
import { Heading } from 'shared/typography';
import { toBase16 } from 'shared/utils/b58';
import { isUUID } from 'shared/utils/uuid';
import { useLocationId } from '../../hooks';
import { useAppDispatch, useAppSelector } from '../../store';
import { BookStepHeading, BusinessOfflineState } from '../shared';
const Location = t0 => {
  const $ = _c(15);
  const {
    location
  } = t0;
  const [, setLocationId] = useLocationId();
  let t1;
  if ($[0] !== location.id || $[1] !== setLocationId) {
    t1 = () => setLocationId(location.id);
    $[0] = location.id;
    $[1] = setLocationId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      cursor: "pointer"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = location.is_virtual ? null : `https://maps.google.com/maps/api/staticmap?key=${__GOOGLE_MAPS_KEY__}&center=${location.gps[0]},${location.gps[1]}&zoom=14&size=150x150&sensor=false&markers=color:red|${location.gps[0]},${location.gps[1]}`;
  let t4;
  if ($[4] !== location.name || $[5] !== t3) {
    t4 = <Avatar size={100} image={t3} name={location.name} icon={faMapMarker} />;
    $[4] = location.name;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== location.name) {
    t5 = <Heading fontWeight={500} fontSize={3} textAlign="center">{location.name}</Heading>;
    $[7] = location.name;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Grid justifyItems="center" pb={4}>{t4}{t5}</Grid>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <Box as="button" onClick={t1} sx={t2}>{t6}</Box>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
const LocationSelector = () => {
  const $ = _c(45);
  const location = useLocation();
  const {
    serviceId: serviceId_
  } = useParams();
  let serviceId = serviceId_;
  if (!isUUID(serviceId)) {
    if (serviceId.length > 1 && serviceId.length < 32) {
      let t0;
      if ($[0] !== serviceId) {
        t0 = toBase16(serviceId);
        $[0] = serviceId;
        $[1] = t0;
      } else {
        t0 = $[1];
      }
      serviceId = t0;
    } else {
      if (serviceId.length !== 32) {
        serviceId = null;
      }
    }
  }
  const serviceId_0 = serviceId;
  const [locationId, setLocationId] = useLocationId();
  const businessId = useAppSelector(_temp);
  let t0;
  if ($[2] !== serviceId_0) {
    t0 = state_0 => state_0.services.data[serviceId_0];
    $[2] = serviceId_0;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const service = useAppSelector(t0);
  const isLoading = useAppSelector(_temp2);
  const bookableData = useAppSelector(_temp3);
  const locationData = useAppSelector(_temp4);
  let t1;
  if ($[4] !== bookableData || $[5] !== businessId || $[6] !== locationData) {
    const locationIdsHavingBookables = Object.values(bookableData).filter(b => b.business_id == businessId).reduce(_temp5, []);
    t1 = Object.values(locationData).filter(l => l.business_id == businessId).filter(l_0 => locationIdsHavingBookables.includes(l_0.id)).sort(_temp6);
    $[4] = bookableData;
    $[5] = businessId;
    $[6] = locationData;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const businessLocationsWithResouces = t1;
  let t2;
  if ($[8] !== locationData || $[9] !== service?.locations) {
    t2 = () => Object.values(locationData).filter(_temp7).filter(l_2 => service?.locations?.find(sl => sl.location_id === l_2.id)).sort(_temp8);
    $[8] = locationData;
    $[9] = service?.locations;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  service?.locations;
  let t3;
  if ($[11] !== t2) {
    t3 = t2();
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const locationsProvidingThisService = t3;
  const dispatch = useAppDispatch();
  const [notFound, setNotFound] = React.useState(false);
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["/request-prescription"];
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const isScriptRequest = t4.includes(location.pathname);
  const locations = isScriptRequest ? businessLocationsWithResouces : locationsProvidingThisService;
  let t5;
  if ($[14] !== dispatch || $[15] !== isScriptRequest || $[16] !== service || $[17] !== serviceId_0) {
    t5 = () => {
      if (!isScriptRequest && !service) {
        dispatch(fetchService(serviceId_0)).catch(e => {
          if (e.response?.status === 404) {
            setNotFound(true);
          }
        });
      }
    };
    $[14] = dispatch;
    $[15] = isScriptRequest;
    $[16] = service;
    $[17] = serviceId_0;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== dispatch || $[20] !== isScriptRequest || $[21] !== location.pathname || $[22] !== service || $[23] !== serviceId_0) {
    t6 = [dispatch, isScriptRequest, location.pathname, service, serviceId_0];
    $[19] = dispatch;
    $[20] = isScriptRequest;
    $[21] = location.pathname;
    $[22] = service;
    $[23] = serviceId_0;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  React.useEffect(t5, t6);
  const firstAndOnlyLocationId = locationsProvidingThisService.length === 1 ? locationsProvidingThisService[0].id : null;
  let t7;
  if ($[25] !== firstAndOnlyLocationId || $[26] !== setLocationId) {
    t7 = () => {
      if (firstAndOnlyLocationId) {
        setLocationId(firstAndOnlyLocationId);
      }
    };
    $[25] = firstAndOnlyLocationId;
    $[26] = setLocationId;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== dispatch || $[29] !== firstAndOnlyLocationId || $[30] !== setLocationId) {
    t8 = [dispatch, firstAndOnlyLocationId, setLocationId];
    $[28] = dispatch;
    $[29] = firstAndOnlyLocationId;
    $[30] = setLocationId;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  React.useEffect(t7, t8);
  const business = useAppSelector(_temp9);
  if (business.is_deleted || business.subscription_status === "cancelled" || !business.online) {
    let t9;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <BusinessOfflineState />;
      $[32] = t9;
    } else {
      t9 = $[32];
    }
    return t9;
  }
  if (notFound) {
    let t9;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <EmptyState heading={<FormattedMessage id="Public.ServiceView.serviceNotFound" defaultMessage="Service not found" />} />;
      $[33] = t9;
    } else {
      t9 = $[33];
    }
    return t9;
  }
  if (isLoading) {
    let t9;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Loader />;
      $[34] = t9;
    } else {
      t9 = $[34];
    }
    return t9;
  }
  const t9 = "/" + (locationId ? `?lid=${locationId}` : "");
  let t10;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FormattedMessage id="Public.LocationSelector.pickALocation" defaultMessage="Select a location to continue" />;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t9) {
    t11 = <BookStepHeading backTo={t9}>{t10}</BookStepHeading>;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== locations) {
    t12 = locations.map(_temp0);
    $[38] = locations;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== t12) {
    t13 = <Grid gridTemplateColumns="repeat(auto-fit, minmax(150px, 1fr))" width="100%" p={8}>{t12}</Grid>;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t11 || $[43] !== t13) {
    t14 = <Grid gridGap={4}>{t11}{t13}</Grid>;
    $[42] = t11;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  return t14;
};
export default LocationSelector;
function _temp(state) {
  return state.public.businessId;
}
function _temp2(state_1) {
  return [state_1.businesses.status, state_1.locations.status].includes("loading");
}
function _temp3(state_2) {
  return state_2.bookables.data;
}
function _temp4(state_3) {
  return state_3.locations.data;
}
function _temp5(acc, curr) {
  curr.location_ids.forEach(lId => {
    if (!acc.includes(lId)) {
      acc.push(lId);
    }
  });
  return acc;
}
function _temp6(a, b_0) {
  return a.name < b_0.name ? -1 : 1;
}
function _temp7(l_1) {
  return !l_1.is_deleted;
}
function _temp8(a_0, b_1) {
  return a_0.name < b_1.name ? -1 : 1;
}
function _temp9(state_4) {
  return state_4.businesses.data[state_4.public.businessId];
}
function _temp0(location_0, idx) {
  return <Location key={idx} location={location_0} data-sentry-element="Location" data-sentry-component="_temp0" data-sentry-source-file="index.tsx" />;
}